document.addEventListener('DOMContentLoaded', function() {
	/*
	jQuery('#slider').slick({
		//centerMode: true,
		slidesToShow: 1,
		//lazyLoad: 'progressive',
		arrows: false,
		dots: false,
		infinite: true,
		variableWidth: true,
		adaptiveHeight: false
	});
	*/
	if (document.querySelector('.swiper:not(.hero-swiper)')) {

		const swiper = new Swiper('.swiper:not(.hero-swiper)', {
			slidesPerView: "auto",
			spaceBetween: 10,
			loop: true
		});

		document.body.addEventListener('click', function(e) {
			if (e.target.closest('.swiper-slide')) {
				e.preventDefault();
				const swiper = document.querySelector('.swiper').swiper;
				swiper.slideNext();
				
			}
		});
	}
});

